import Swal from "sweetalert2";
import { set_token, set_user_details,getCookie, csrf_headers } from "@/router";
import { client_domain } from "@/main.js";


export default {
    data() {
        return ({
            login_url: '',
            first_name: '',
            last_name: '',
            email: '',
            phone_number: '',
            user_type: 'parent',
            password: '',
            confirm_password: '',
            passwordVisible: false,
            confirmPasswordVisible: false,
            errors: {},
            passed: false,
            cbo_domain: false,
            vettedsa_domain: false,
            csrfToken: '',
            school_domain: false
        });
    },
    mounted() {
        if (client_domain.includes('cbo')) {
            this.cbo_domain = true;
        }
        if (client_domain.includes('vettedsa')) {
            this.vettedsa_domain = true;
        }
        this.csrfToken = getCookie('csrftoken');
        if (client_domain.includes('chiefluthuli')) {
            this.school_domain = true;
        }
    },
    methods: {
        apply_registration_field_error(response_status) {
            if (response_status?.status !== 'error') {
                return false;
            }

            const response_message = String(response_status.message || '').toLowerCase();
            if (response_message.includes('email')) {
                this.errors.email = response_message;
                return true;
            }

            if (response_message.includes('phone number')) {
                this.errors.phone_number = response_message;
                return true;
            }

            return false;
        },
        get_registration_general_error(httpStatus, textStatus) {
            if (httpStatus === 403) {
                return 'Forbidden (403). CSRF token missing/invalid or cookies not included.';
            }

            if (httpStatus) {
                return `Request failed (HTTP ${httpStatus}).`;
            }

            return `Request failed (${textStatus || 'network error'}).`;
        },
        async ensure_csrf_cookie() {
            const csrfUrl = `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_csrf_token/`;
            try {
                await fetch(csrfUrl, {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Page-URL': window.location.href,
                    },
                });
            } catch (e) {
                console.warn('Failed to refresh CSRF cookie', e);
            } finally {
                this.csrfToken = getCookie('csrftoken') || this.csrfToken;
            }
        },

        async register_user() {
            this.validateForm();

            if (!this.passed) {
                return;
            }

            await this.ensure_csrf_cookie();

            Swal.fire({
                title: 'Saving...',
                text: 'Please wait while we save the user data.',
                allowOutsideClick: false,
                showConfirmButton: false,
                onOpen: () => {
                    Swal.showLoading();
                }
            });

            const baseUrl = `${window.location.origin}`;

            $.ajax({
                type: "POST",
                url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/register_user/`,
                xhrFields: { withCredentials: true },
                headers: {
                    'Content-Type': 'application/json',
                    ...csrf_headers(this.csrfToken)
                },
                data: JSON.stringify({
                    role: "user",
                    email: this.email,
                    last_name: this.last_name,
                    first_name: this.first_name,
                    phone_number: this.phone_number,
                    user_type: this.user_type,
                    password: this.password,
                    base_url: baseUrl
                }),
                success: (response) => {
                    if (response.status === "success") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Registration Successful',
                            showConfirmButton: false,
                            timer: 2000,
                            position: 'bottom-end',
                            toast: true
                        }).then(() => {
                            let redirect_url = '/sign_in_finale';
                            const response_data = response.data;

                            if (this.cbo_domain) {
                                set_token(response_data.token);
                                set_user_details(response_data.user_details);
                                redirect_url = '/view_events';
                            }

                            window.location.href = redirect_url;
                        });
                    }
                },
                error: (jqXHR, textStatus, errorThrown) => {
                    this.handle_registration_error(jqXHR, textStatus, errorThrown);
                }
            });
        },
        handle_registration_error(jqXHR, textStatus, errorThrown) {
            Swal.close();

            const response_status = jqXHR?.responseJSON || null;
            if (this.apply_registration_field_error(response_status)) return;

            const httpStatus = jqXHR?.status;
            this.errors.general = this.get_registration_general_error(httpStatus, textStatus);

            console.warn('register_user failed', {
                httpStatus,
                textStatus,
                errorThrown,
                response_status
            });
        },
        validateForm() {
            let valid = true;

            if (!this.first_name && this.first_name.length <= 3) {
                this.errors.first_name = 'First name is required';
                valid = false;
            } else {
                this.errors.first_name = '';
            }

            if (!this.last_name && this.first_name.length <= 3) {
                this.errors.last_name = 'Last name is required';
                valid = false;
            } else {
                this.errors.last_name = '';
            }

            if (!this.email) {
                this.errors.email = 'Email is required';
                valid = false;
            } else if (!this.isValidEmail(this.email)) {
                this.errors.email = 'Please enter a valid email';
                valid = false;
            } else {
                this.errors.email = '';
            }


            if (!this.password) {
                this.errors.password = 'Password is required';
                valid = false;
            } else if (!this.isValidPassword(this.password)) {
                this.errors.password = 'Password must be at least 8 characters, contain at least one uppercase letter, one lowercase letter, one digit, and one special character';
                valid = false;
            } else {
                this.errors.password = '';
            }

            if (!this.confirm_password) {
                this.errors.confirm_password = 'Confirm password is required';
                valid = false;
            } else if (this.password !== this.confirm_password) {
                this.errors.confirm_password = 'Passwords do not match';
                valid = false;
            } else {
                this.errors.confirm_password = '';
            }

            this.passed = valid;
        },
        isValidEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(String(email).toLowerCase());
        },
        isValidPhoneNumber(phone_number) {
            const re = /^[\d\-+()]+$/;
            return re.test(phone_number);
        },

        togglePasswordVisibility(field) {
            if (field === 'password') {
                this.passwordVisible = !this.passwordVisible;
            } else if (field === 'confirm') {
                this.confirmPasswordVisible = !this.confirmPasswordVisible;
            }
        },
        isValidPassword(password) {
            const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
            return re.test(password);
        },


    }
};



